export default {
    install: function(Vue, options) {
        Vue.filter('fixar2digitos', function(valor, valorPadrao = null) {
          if (!valor) return valorPadrao || valor;
          
          return valor.toString().includes(',') ? valor : `${valor},00`;
        });
    }
}



// WEBPACK FOOTER //
// ./FrontEnd/filtros/fixar2digitos.js